import { SUBSCRIPTION_PLAN } from 'src/data/subscription';
import { trackHubspotEvent as mutationTrackHubspotEvent } from 'src/graphql/event';
import { captureMessage } from 'src/lib/sentry';

export const HUBSPOT_EVENT = {
  clickedUpgradeButton: 'clicked_upgrade_button',
};

export const HUBSPOT_SUBSCRIPTION_ACTION = {
  buyNow: 'buy_now',
  bookDemo: 'book_a_demo',
};

const HUBSPOT_SUBSCRIPTION_PLAN_VALUE = {
  basic: 'basic',
  starter: 'starter',
  dataDriven: 'data_driven',
  businessSelfServe: 'business_self_serve',
  business: 'business',
  enterprise: 'enterprise',

  // Not used anymore values
  /*
  acquisition: 'acquisition',
  conversion: 'conversion',
  engagement: 'engagement',
  */
};

export const trackHubspotEvent = (eventName, attributes) => {
  mutationTrackHubspotEvent(eventName, attributes).catch((error) => {
    captureMessage('Error tracking Hubspot event', {
      level: 'warning',
      extra: {
        error: error.toString(),
        source: 'lib/events/hubspot -> trackHubspotEvent',
        eventName,
        attributes,
      },
    });
  });
};

export const convertSubscriptionPlanForHubspot = (plan) => {
  switch (plan) {
    case SUBSCRIPTION_PLAN.basic:
      return HUBSPOT_SUBSCRIPTION_PLAN_VALUE.basic;

    case SUBSCRIPTION_PLAN.starter:
    case SUBSCRIPTION_PLAN.starterLegacy:
      return HUBSPOT_SUBSCRIPTION_PLAN_VALUE.starter;

    case SUBSCRIPTION_PLAN.dataDriven:
    case SUBSCRIPTION_PLAN.ddTeamsLegacy:
      return HUBSPOT_SUBSCRIPTION_PLAN_VALUE.dataDriven;

    case SUBSCRIPTION_PLAN.businessSelfServeLegacy:
      return HUBSPOT_SUBSCRIPTION_PLAN_VALUE.businessSelfServe;

    case SUBSCRIPTION_PLAN.business:
    case SUBSCRIPTION_PLAN.businessPlus:
    case SUBSCRIPTION_PLAN.businessMax:
    case SUBSCRIPTION_PLAN.proPublisherLegacy:
      return HUBSPOT_SUBSCRIPTION_PLAN_VALUE.business;

    case SUBSCRIPTION_PLAN.performance:
    case SUBSCRIPTION_PLAN.performancePlus:
    case SUBSCRIPTION_PLAN.performanceMax:
    case SUBSCRIPTION_PLAN.enterpriseLegacy:
      return HUBSPOT_SUBSCRIPTION_PLAN_VALUE.enterprise;

    default:
      return plan;
  }
};
